import { IconButton, Tooltip } from "@mui/material";
import { ReactComponent as InfoIcon } from "Components/_Shared/Icons/Assets/info.svg";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import type { FC } from "react";

type Props = {
  title: string;
};

export const InfoTooltip: FC<Props> = ({ title }) => {
  const { t } = useResource();

  return (
    <Tooltip title={title}>
      <IconButton
        type="button"
        aria-label={t(Resources.Common.MoreInfo)}
        disableRipple
        sx={{
          p: 0,
          alignSelf: "center",
          color: "grey.500",
          "&:hover": { color: "grey.800", backgroundColor: "transparent" },
          // The asset ships at 20x20; both dimensions must be pinned to 16 or the icon box stays 20px
          // tall and sits off-centre next to a 14px label.
          "& svg": { display: "block" },
        }}
      >
        <InfoIcon width="16px" height="16px" color="currentColor" />
      </IconButton>
    </Tooltip>
  );
};
